<template>
  <v-container v-if="$store.state.csData">
    <v-expansion-panels v-model="openPanel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div left><v-icon class="mr-3">mdi-forum</v-icon>Enter Profile</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <ProfileInput v-model="user" @openPanels="openPanel = [1, 2]" />
          <ColourWheel v-model="user" :height="`${vh * 0.4}px`" />
          <BarChart :value="user" :height="`${vh * 0.25}px`" />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel :disabled="!$store.getters.getUserProfile">
        <v-expansion-panel-header>
          <div left>
            <v-icon class="mr-3">mdi-chart-bubble</v-icon>Bubble Chart
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <BubbleChart :height="`${vh * 0.95}px`" />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel :disabled="!$store.getters.getUserProfile">
        <v-expansion-panel-header>
          <div left>
            <v-icon class="mr-3">mdi-table-large</v-icon>Data Table
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <JobListDataTable />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-card v-if="endDate >= df.startOfToday() && endDate <= df.addWeeks(df.startOfToday(), 1)">
      <v-card-title class="headline my-10" v-if="df.differenceInDays(endDate, df.startOfToday())">
        Your subscription expires in
        {{ df.differenceInDays(endDate, df.startOfToday()) }} days!
      </v-card-title>
      <v-card-title class="headline my-10" v-else>
        Your subscription expires today!
      </v-card-title>
      <v-card-subtitle
        >Please contact ColourSpectrums by
        {{ df.format(endDate, "MMMM do, yyyy") }} to extend your
        subscription.
      </v-card-subtitle>
    </v-card>
  </v-container>
</template>

<script>
import ProfileInput from "../components/ProfileInput";
import ColourWheel from "../components/ColourWheel";
import BarChart from "../components/BarChart";
import BubbleChart from "../components/BubbleChart";
import JobListDataTable from "../components/JobListDataTable";
import axios from "axios";
import * as df from "date-fns";

export default {
  name: "Main",
  data() {
    return {
      df,
      user: {
        userName: "User",
        noc: "0000",
        blue: 0,
        green: 0,
        red: 0,
        yellow: 0,
      },
      openPanel: [0],
    };
  },
  computed: {
    vh() {
      return Math.min(
        this.$vuetify.breakpoint.height,
        this.$vuetify.breakpoint.width
      );
    },
    endDate() {
      return df.parseISO(this.localStorage.endDate);
    },
  },
  async beforeMount() {
    const result = await axios({
      method: "get",
      url: process.env.VUE_APP_API_ADDRESS + "enddate",
      headers: { token: this.localStorage.token },
    });
    this.localStorage.endDate = result.data;
  },
  created() {
    this.$store.dispatch("loadCsData");
  },
  async beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      if (vm.localStorage.token) {
        const result = await axios({
          method: "get",
          url: process.env.VUE_APP_API_ADDRESS + "userverify",
          headers: { token: vm.localStorage.token },
        });
        if (result.data == "passed") return next();
        console.log(result.data);
        vm.localStorage.token = null;
        vm.localStorage.accessLevel = null;
        vm.localStorage.email = null;
        vm.localStorage.endDate = null;
        if (result.data == "expired") return next("/inactive");
      }
      return next("/");
    });
  },
  components: {
    ProfileInput,
    ColourWheel,
    BarChart,
    BubbleChart,
    JobListDataTable,
  },
};
</script>

<style>
.blue-fill {
  fill: #40c4ff;
}
.green-fill {
  fill: #00c853;
}
.red-fill {
  fill: #ff5252;
}
.yellow-fill {
  fill: #ffeb3b;
}
</style>
